import { useNavigate } from 'react-router-dom';
import NFLCreateLeagueWizard from '@/components/nfl/NFLCreateLeagueWizard';

export default function NFLCreateLeaguePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-dark overflow-x-hidden overflow-y-auto w-full">
      <main className="w-full px-4 sm:px-6 py-6 mx-auto max-w-lg">
        <NFLCreateLeagueWizard
          onComplete={() => navigate('/nfl')}
          onClose={() => navigate(-1)}
        />
      </main>
    </div>
  );
}
